import { useRentalManagerUserPropertyMultiplexWebApiHandler_archive } from '@zg-rentals/ts-rental-manager-api-client-react-query';

import type { MutateOptions } from '@zg-rentals/react-query5';
import type { RentalManagerUserPropertyMultiplexWebApiHandler_archive_Args } from '@zg-rentals/ts-rental-manager-api-client-react-query';

type ArchiveMultiplexPropertyMutateOptions = MutateOptions<
  void,
  unknown,
  RentalManagerUserPropertyMultiplexWebApiHandler_archive_Args
>;

/**
 * Archives all units in a multiplex property via /api/web/v1/users/properties/multiplex/archive.
 */
export const useArchiveMultiplexProperty = (
  options?: Parameters<typeof useRentalManagerUserPropertyMultiplexWebApiHandler_archive>[0],
) => {
  const mutation = useRentalManagerUserPropertyMultiplexWebApiHandler_archive(options);

  const archiveMultiplexProperty = (groupId: string, mutateOptions?: ArchiveMultiplexPropertyMutateOptions) =>
    mutation.mutate({ postData: { groupId } }, mutateOptions);

  return { ...mutation, archiveMultiplexProperty };
};
